export const hcUrl = {
  token: "token",
  login: "Login?Value=",
  // resumeSaving:"Api/Resume/ResumeSaving",
  postBasic: "Career/SaveBasicDetails",
  getBasic: "Career/BasicDetails/",
  getContact: "Career/ContactDetails/",
  getEducation: "Career/AcademicDetails/",
  getEmployee: "Career/EmploymentDetails/",
  getlanguage: "Career/LanguageInfo/",
  adminJob: "AdminJobs/list",
  applicantJobs: "Jobs/list",
  indentById: "Jobs/",
  postJob: "PostJob",
  updateJob: "UpdateJobDescription",
  jobApply: "Career/JobApply?isCareer=true",
  uploadResume: "Career/UploadResume",
  parseResume: "Career/ParseResume",
  saveContactInfo: "Career/SaveContactInfo",
  saveAcademicInfo: "Career/SaveAcademicInfo",
  saveWorkExperience: "Career/SaveWorkExperience",
  saveLanguageInfo: "Career/SaveLanguageInfo",
  applicationSummary: "Career/ApplicationSummary/",
  contactDetails: "ContactDetails",
  academicDetails: "AcademicDetails/",
  employmentDetails: "EmploymentDetails/",
  languageInfo: "LanguageInfo/",
  iStudioDetails: "IStudioDetails/",
  offerLetterDocument: "OfferLetterDocument",
  upploadDocument: "Recruiter/Applicants/UpploadDocument",
  updateBasicDetails: "UpdateBasicDetails",
  resumeSaving: "Career/SaveResume",
  GetReferredCandidateList:
    "api/Requirement/GetReferredCandidateList?employeid=",
  UpdateDeclaration: "UpdateDeclaration",
  GetDeclaration: "GetDeclaration/",
  getEducationType: "Career/GetEducationType?RID=",
  geResumeHC: "Recruiter/Applicants/GetResume/",
  getApplicantHistory: "Career/getApplicantHistory/",
  saveSkill:"Career/SaveSkillInfo",
  saveCertification:"Career/SaveCertificationInfo",
  getPublication:"Career/PublicationsInfo/",
  getSkill:"Career/SkillInfo/",
  getCertification:"Career/CertificationInfo/",
  whatsappconsent:"Recruiter/whatsappconsent",

  savePublication:"Career/SavePublicationsInfo",
};
export const hcMaster = {
  countryMaster: "Country",
  stateMaster: "State/",
  cityMaster: "City/",
  degreeMaster: "Degree",
  universityMaster: "University",
  collegeMaster: "College",
  specializationMaster: "Specialization",
  designation: "Designation",
  currency: "Currency",
  department: "Department",
  emptype: "EmploymentType",
  language: "Language",
  industry: "industry",
  educationgroup: 'GetMaster?name=educationgroup',
  skill:"skill",
  Rating:"Rating"
};

export const magUrl = {
  banner: "Career/Banner/1",
  token: "getToken",
  loginLdap: "LdapLogin",
  post: "Allpost",
  report: "Report",
  insertPost: "InsertPost",
  likePost: "LikePost",
  comments: "Comments",
  allJobs: "AllJobs/2",
  getMoreJobsOnScroll: "Career/GetMoreJobs",
  applicantLogin: "login",
  applicantSignup: "registration",
  billboard: "billboard/1",
  portfolio: "Career/portfolio/1",
  portfolioPreview: 'portfolioPreview/',
  RelatedPortfolio: 'getRelatedPortfoliosByID',
  relatedDoc: "relatedDocumentByID",
  featuredjobs: "Career/getFeaturedJobs/1",
  featuredfeeds: "getAllFeaturedFeed",
  news: "getnews/:postedTo",
  groups: "groups",
  groupRealatedJobs: "getGroupRelatedJob",
  realtedjob: "Career/getRelatedJobByID/1",
  searchApi: "Search/1",
  form: "FormById/",
  signUp: "signUp",
  createNewUser: "createNewUser",
  updateUserProfile: "updateUserProfilePic",
  getApplicantProfile: "/Career/getApplicantProfile/",
  jobliked: "jobLike",
  isjobliked: "isjobLiked",
  insertbookmark: "insertbookmark",
  GFLlogin: "GFLlogin",
  saveAppliedJobsHc: "saveAppliedJobsHc",
  AppliedJobsHc: "getUserAppliedJobsHc/",
  isbookmarked: "isbookmark",
  joblikecount: "jobLikeCount",
  getallbookmark: "getbookmark",
  referfriend: "create_refer_a_friend",
  getUserSingleuserJourney: "userJourney/",
  singlejob: "getSingleJob/1/",
  previewjob: "getPreviewJob/1/",
  allJobLike: "AllJobLike/",
  userDataUpdate: "userEmailMobileUpdate",
  rChilli: "getRchilliData",
  rchillijson: "getRchilliJSON",
  rchillijsondata: "setRchilliJSON",
  recommdenedjob: "recommdenedJob",
  ourrecommdenedjob: "getOurrecommdenedJob",
  searchsuggestionApi: "career/SearchSuggestion",
  insertNotificationData: "insertNotificationData",
  checkuseralreadyapplied: "userAlreadyApplied",
  forgotPassword: "ForgotPassword",
  getalledxbookmark: "getedxbookmark",
  storesrLogs: "StoreSrLogs",
  getSRAllLogs: "getAllSRlogs",
  uploadAppResumeMg: "UploadResume",
  AddUpdatesocialHandle: "SocialHandle",
  SearchBot: "SearchBot",
  getRandomImagesForNotification: "GetRandomImages",
  ITVGet: "GetDemoUrl/1",
  Edxurl1: "OpenEdxCourses",
  Edxurl2: "EdxCourses",
  Coverphoto: "UploadCoverphoto",
  GetAllCourse: "Career/getAllCourses",
  GetCourseById: "Career/getCourseById",
  GetCoursejobs: "GetCourseRelatedJobs",
  GetPremiumCoursejobs: "GetCourseRelatedJobs",
  UpdateCourseLog: "updateCourseLog",
  SaveCandidateId: "SaveCandidateId",
  postImage: "post_image/",
  AllTVLike: "AllTVLike/",
  TVLike: "TVLike",
  insertITVbookmark: "insertITVbookmark",
  tvLikeCount: "tvLikeCount",
  AllCourseLike: "AllCourseLike/",
  courseLike: "courseLike",
  courseLikeCount: "courseLikeCount",
  removeResume: "removeResume/",
  raiseTicket: "tms/create-issue-un/",
  getAllTicket: "tms/get-all-tickets/",
  getTicketStatus: "/tms/check-service-ticket-status/",
  groups: "Groups",
  postBySearch: "postBySearch",
  getallStory: "Career/GetAllStories",
  SaveDetails:"SaveDetails"
};

export const Ngrok = {
  banner: "Banner/1"
}

export const magMasterUrl = {
  groupName: "GroupName",
};


export default {
  magUrl,
  hcMaster,
  hcUrl,
  magMasterUrl,
};
